import { useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CheckCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { CustomButton } from '../../../../../components/CustomButton'
import WMSCodOperService from '../../../../../services/database/WMSCodOperService'
import { isSomePropEmpty } from '../../../../../utils/obj'
import { sendErrorApiMessage } from '../../../../../utils/sendErrorApiMessage'

export function ModalCreate({ isOpen, onClose, loadCodigos }) {
  const [data, setData] = useState({
    descricao: '',
    codoper: '',
  })
  const [isCreateRequestLoading, setIsCreateRequestLoading] = useState(false)

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleCreateCodigo() {
    try {
      setIsCreateRequestLoading(true)

      await WMSCodOperService.create(data)

      loadCodigos()
      toast.success('Código criada com sucesso!')
      onClose()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao criar o código!')
    } finally {
      setIsCreateRequestLoading(false)
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header>
        <Modal.Title>Cadastrar Código</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col>
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              name="descricao"
              value={data.descricao}
              onChange={handleChange}
              placeholder="Digite"
            />

            <Form.Label className="mt-3">Tipo</Form.Label>
            <Form.Select
              name="codoper"
              value={data.codoper}
              onChange={handleChange}
            >
              <option value="">Selecione</option>
              <option value="E">Entrada</option>
              <option value="S">Saída</option>
              <option value="E/S">Entrada/Saída</option>
            </Form.Select>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          isDisabled={isSomePropEmpty(data)}
          title="Cadastrar"
          color="#0d9a04"
          onClick={handleCreateCodigo}
          isLoading={isCreateRequestLoading}
          isLoadingText="Cadastrando..."
        >
          <CheckCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
